export default __webpack_public_path__ + "static/B0023-e6d92b51aace8641d814a2e0e1e845d7.png";